import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import api from "../utils/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./homecasino.css";
import LoginModal from "../userAuth/LoginModal";

const CasinoHome = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { token, user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [showLogin, setShowLogin] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeNav, setActiveNav] = useState("all");
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nextCursor, setNextCursor] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const navRef = useRef(null);

  const fetchGames = async (cursor = null) => {
    try {
      if (!cursor) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      const queryParams = new URLSearchParams({
        limit: 20,
      });

      if (cursor) queryParams.append("cursor", cursor);
      if (activeNav !== "all") queryParams.append("gameType", activeNav);
      if (searchQuery) queryParams.append("name", searchQuery);
      if (selectedProviders.length > 0) {
        queryParams.append("providers", selectedProviders.join(","));
      }

      const gamesRes = await api.get(`/games?${queryParams.toString()}`);

      if (gamesRes.data.success) {
        if (cursor) {
          setGames((prev) => [...prev, ...gamesRes.data.data]);
        } else {
          setGames(gamesRes.data.data);
        }

        setNextCursor(gamesRes.data.pagination?.nextCursor);
      }
    } catch (error) {
      console.error("Error fetching games data:", error);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchGames();
  }, [activeNav, searchQuery, selectedProviders]);

  const handleGameClick = (slug) => {
    if (!token) {
      setShowLogin(true);
    } else {
      navigate(`/games/${slug}`);
    }
  };
  return (
    <>
      <div className="table-responsive bg-black">
        <table
          className="table table-dark align-middle table-hover custom-table mb-0"
          style={{ backgroundColor: "#000", color: "#fff" }}
        >
          <thead className="table-dark">
            <tr>
              <th>Name</th>
              <th>Created Date & Time</th>
              <th>Category</th>
              <th>Provider</th>
              <th>Valid</th>
            </tr>
          </thead>

          <tbody style={{ backgroundColor: "black" }}>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  Loading...
                </td>
              </tr>
            ) : games && games.length > 0 ? (
              games.map((g, i) => (
                <tr
                  key={g._id || i}
                  onClick={() => handleGameClick(g?.slug)}
                  style={{
                    cursor: "pointer",
                    backgroundColor: i % 2 === 0 ? "#111111" : "#1a1a1a",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#0d6efd";
                    e.currentTarget.style.transform = "scale(1.01)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      i % 2 === 0 ? "#111111" : "#1a1a1a";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <td className="fw-semibold">{g?.name}</td>

                  <td className="text-success fw-semibold">
                    {new Date(g?.createdAt).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </td>

                  <td className="text-capitalize">{g?.gameType}</td>

                  <td style={{ color: "green", fontWeight: "600" }}>
                    {g?.provider?.name}
                  </td>

                  <td>
                    <span
                      className={`badge ${
                        g?.status ? "bg-primary" : "bg-danger"
                      }`}
                    >
                      {g?.status ? "Active" : "Inactive"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4">
                  No Games Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <LoginModal show={showLogin} handleClose={() => setShowLogin(false)} />
    </>
  );
};

export default CasinoHome;
